import { FC } from 'react'

import {KTSVG} from '../../../../../_metronic/helpers'

type Props = {
    appState: string
    doClose: Function
}
const SubmitInspectionHeader: FC<Props> = ({appState, doClose}) => {
    return (
    <div className='modal-header'>      

        <div>                
        { appState === 'Inspector Reviewer Review - Issue' ? (
            <>
            <div className="text-muted fw-normal fs-8 my-2">{appState}</div>
            <h2 className='fw-bolder'>
                Inspector Response
                <div className="text-muted fw-light fs-6 mt-2">Submit response to Interviewer (Reviewer) comments.</div>
            </h2>              
            </>
        ) : (
            <>
            <div className="text-muted fw-normal fs-8 my-2">
                Inspection
            </div>                          
            <h2 className='fw-bolder'>
                {appState}            
            </h2> 
            </>             
        )}
        </div>

        <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-producttypes-modal-action='close'        
            style={{cursor: 'pointer'}}
            onClick={() => doClose()}
        >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
        </div>      
    </div>
    )
}

export {SubmitInspectionHeader}
